<template>
    <div id="viewer">
        <Header />
        <Viewerheader :initWebtoonInfo="webtoonInfo" :initEpisodeIdx="currEpisodeIdx" :initEpisodeState="episodeState" />
        <div class="container">

            <img v-for="(item,index) in imageList" :key="index" 
                :src="  host + '/episode/image/view/' 
                        + $store.state.ticket + '/'
                        + $store.state.sign + '/'
                        + currWebtoonIdx + '/'
                        + currEpisodeIdx + '/'
                        + item.page + '/'
                        + 'KR'"
            />
            
            <!-- <div class="next_see">
                <img src="../assets/images/viewer/viewer1.webp" alt="썸네일">
                <div class="text">
                    <p>다음화 보기(4화)</p>
                    <p class="name">배추나비흰나비</p>
                </div>
                <img src="../assets/images/viewer/icon_next.svg" alt="next" class="next_arrow">
            </div> -->
            <div class="group" v-if="episodeList.length > 0">
                <div class="prev" @click="prevPage()">prev</div>
                    <div class="toon" v-for="(item, index) in episodeList" :key="index" :class="[item.episodeIdx === currEpisodeIdx ? 'now' : 'secret']" @click="changeEpisode(currWebtoonIdx, item.episodeIdx)">
                        <img :src="siteConfig.cdnUrl + '/KR/' + item.url" alt="썸네일" class="ssum">
                        <p>{{item.episodeIdx}}화</p>
                    </div>
                <div class="next" @click="nextPage()">next</div>
            </div>
            <div class="buttons">
                <div class="list" @click="backList">목록 보기</div>
                <!-- <div class="all" @click="showAllBuyPopup">전 회차 소장하기</div> -->
            </div>
        </div>
        <Footer />
        <Viewermove :initWebtoonInfo="webtoonInfo" :initEpisodeState="episodeState"/>
        <Login :initIsShowPopup="isShowLoginPopup" @close="close('Login')" />
        <Buy  :initIsShowPopup="isShowBuyPopup" :initWebtoonInfo="webtoonInfo" :initEpisodeInfo="chagneEpisodeInfo" :initSiteConfig="siteConfig" @close="close('Buy')"  />
        <!-- <Allbuy  :initIsShowPopup="isShowAllBuyPopup" :initWebtoonInfo="webtoonInfo" :initBuyAllInfo="BuyAllInfo" :initSiteConfig="siteConfig" @close="close('AllBuy')"  /> -->
    </div>
</template>

<script>
import Viewerheader from '@/components/Viewerheader.vue'
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Viewermove from '@/components/Viewermove.vue'
import Buy from '@/components/Buy.vue'
import Login from '@/components/Login.vue'
// import Allbuy from '@/components/Allbuy.vue'

export default {
    name: 'Viewer',
    pageCategory: '',
    components: {
        Viewerheader,
        Footer,
        Header,
        Viewermove,
        Buy,
        Login,
        // Allbuy,
    },
    data() {
        return {
            currWebtoonEngName: '',
            currWebtoonIdx: 0,
            currEpisodeIdx: 0,

            webtoonInfo: null,
            episodeState: null,
            imageList: [],
            episodeList: [],
            BuyAllInfo: null,
            chagneEpisodeInfo: null,

            selectedEpisodieInfo: null,

            isShowLoginPopup: false,
            isShowBuyPopup: false,
            isShowAllBuyPopup: false,

            currentPageNo: 1,      //현재 페이지 번호
            currentPageSize: 7,    //한번에 불러올 게시물 수
            maxPageCount:1,        //한 화면에 보여질 페이지 수

            listCount: 0,
            pageCount: 0,
            pageNo: 0,
            pageSize: 0,
            totalRecordSize: 0,

            pageList:[],
        }
    },
    async created(){
        await this.mixinLoginCheck();
        await this.mixinSiteConfigCheck();

        if(this.$route.params.wtidx){
            this.currWebtoonIdx = Number(this.$route.params.wtidx);
        }else{
            this.$router.push('/');
        }

        // if(this.$route.params.engName){
        //     this.currWebtoonEngName = this.$route.params.engName;
        // }else{
        //     this.$router.push('/');
        // }

        if(this.$route.params.epidx){
            this.currEpisodeIdx = Number(this.$route.params.epidx);
        }else{
            this.$router.push('/');
        }
        
        if(!this.$store.state.loginCheck){
            this.$router.push('/');
        }else{
            // await this.getWebtoonInfoName();
            await this.getWebtoonInfo();
            await this.getEpisodeState();
            await this.getImageList();
            var start_idx = 1;
            var end_idx = this.currentPageSize;

            if(this.currEpisodeIdx === 0){
                this.currentPageNo = 1;
                this.getEpisodeList();
            }
            else{
                for(var i=1;i<100;i++)
                {

                    if(this.currEpisodeIdx >= start_idx && this.currEpisodeIdx <= end_idx){
                        this.currentPageNo = i;
                        await this.getEpisodeList();

                        var isContain = false;
                        this.episodeList.forEach(element =>{
                            if(element.episodeIdx === this.currEpisodeIdx){
                                isContain = true;
                            }
                        });

                        if(!isContain){
                            this.currentPageNo ++;
                            this.getEpisodeList();
                        }

                        break;
                    }else{
                        start_idx = start_idx + this.currentPageSize;
                        end_idx = end_idx + this.currentPageSize
                    }
                }
            }
        }
    },
    mounted(){
    },
    methods: {
        prevPage(){
            if(this.currentPageNo > 1){
                this.currentPageNo--;
                this.getEpisodeList();
            }
        },
        nextPage(){
            if(this.currentPageNo < this.pageCount){
                this.currentPageNo++;
                this.getEpisodeList();
            }
        },
        async getImageList(){
            var param = 
            {
                pageNo: 1,
                pageSize: 1000,
                episodeIdx: this.currEpisodeIdx,
                webtoonIdx: this.currWebtoonIdx,
                lang: 'KR'
            }
            await this.$Axios.post(`${this.host}/episode/image/list`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log('----image list----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.imageList = res.data.list;
                }else{
                    console.log(res.data.description);
                    this.$router.push('/');
                    // this.$router.push('/Toondetail/' + this.currWebtoonEngName);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        async getWebtoonInfo(){
            var param = 
            {
                idx: this.currWebtoonIdx,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0,
            }
            await this.$Axios.post(`${this.host}/webtoon`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.webtoonInfo = res.data.data;
                }else{
                    // console.log(res.data.returnCode);
                    this.$router.push('/');
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        async getWebtoonInfoName(){
            var param = 
            {
                wtName: this.currWebtoonEngName,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0,
            }
            await this.$Axios.post(`${this.host}/webtoon/name`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log('----webtoon info name----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.webtoonInfo = res.data.data;
                    this.currWebtoonIdx = this.webtoonInfo.webToonIndex;

                    if(this.webtoonInfo.adult === 1){
                        if(this.$store.state.loginCheck === false){
                            this.$router.push('/');
                        }
                        else if(this.$store.state.adult === false){
                            this.$router.push('/');
                        }
                    }
                }
                // else if(res.data.returnCode === 301){
                //     console.log(res.data.description);
                //     this.$router.push('/');
                // }
                else{
                    console.log(res.data.description);
                    this.$router.push('/');
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        async getEpisodeList(){
            var param = 
            {
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0,
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                wtIdx: this.currWebtoonIdx,
            }
            // console.log(param);
            await this.$Axios.post(`${this.host}/webtoon/episode`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log('----episode list----');
                // console.log(res);
                if (res.data.returnCode === 0) {
                    this.episodeList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    // this.changePage();
                }else{
                    console.log(res.data.description);
                    this.$router.push('/');
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        async getEpisodeState(){
            var param = 
            {
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0,

                webtoonIdx: this.currWebtoonIdx,
                episodeIdx: this.currEpisodeIdx,
                lang: 'KR'
            }
            await this.$Axios.post(`${this.host}/episode/state`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log('----episode state----');
                // console.log(res);
                if (res.data.returnCode === 0) {
                    this.episodeState = res.data;
                }
                else{
                    this.$router.push('/');
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        backList(){
            this.$router.push('/Toondetail/' + this.currWebtoonIdx);
        },
        changeEpisode(wtIdx, epIdx){
            var param = 
            {
                ticket: this.$store.state.ticket,
                sign: this.$store.state.sign,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0,

                webtoonIdx: wtIdx,
                episodeIdx: epIdx,
                lang: 'KR'
            }
            this.$Axios.post(`${this.host}/episode/state`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log('----episode state----');
                // console.log(res);

                if(res.data.epData != null){
                    this.chagneEpisodeInfo = res.data.epData;
                }

                if (res.data.returnCode === 0) {
                    this.$router.push('/Viewer/' + wtIdx + '/' + epIdx);
                }
                else if(res.data.returnCode === 503){   //로그인 필요
                    this.isShowLoginPopup = true;
                }
                else if(res.data.returnCode === 504){   //구매 필요
                    this.isShowBuyPopup = true;
                }
                else{
                    console.log(res.data.dsscription);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        showAllBuyPopup(){
            if(this.$store.state.loginCheck === false){
                this.isShowLoginPopup = true;
            }
            else{
                var param = 
                {
                    idx: this.currWebtoonIdx,
                    ticket: this.$store.state.ticket,
                    sign: this.$store.state.sign,
                }
                this.$Axios.post(`${this.host}/episode/all/price`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                    // console.log(res.data);
                    if (res.data.returnCode === 0) {
                        this.BuyAllInfo = res.data;
                        if(this.BuyAllInfo.sumPrice > 0){
                            this.isShowAllBuyPopup = true;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            }
        },
        close(popupType){
            switch(popupType){
                case 'AllBuy':
                    this.isShowAllBuyPopup = false;
                    break;
                case 'Login':
                    this.isShowLoginPopup = false;
                    break;
                case 'Buy':
                    this.isShowBuyPopup = false;
                    break;
            }
        },
    }
}
</script>